<template>
  <div class="d-flex justify-center mt-16">
    <WaitLoader></WaitLoader>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import WaitLoader from '@/components/WaitLoader.vue'

const router = useRouter()

onMounted(init)

async function init() {
  return await router.push('/welcome_back')
}
</script>
